export default {
  // 查询物流
  getLogisticsManagement: {
    method: 'get',
    url: '/api/getLogisticsManagement'
  },
  // 新增物流
  createLogisticsManagement: {
    method: 'post',
    url: '/api/createLogisticsManagement'
  },
  // 修改物流
  updateLogisticsManagement: {
    method: 'put',
    url: '/api/updateLogisticsManagement'
  },
  // 新增物流
  deleteLogisticsManagement: {
    method: 'delete',
    url: '/api/deleteLogisticsManagement'
  }
}
